import { useMemo } from 'react';

const SCALE_STEPS = [0.5, 0.6, 0.7, 0.8, 0.9, 1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 1.75, 2.0];
const DEFAULT_INDEX = 5; // 1.0

interface CardSizeSliderProps {
  scale: number;
  onScaleChange: (scale: number) => void;
}

export default function CardSizeSlider({ scale, onScaleChange }: CardSizeSliderProps) {
  const currentIndex = useMemo(() => {
    const idx = SCALE_STEPS.indexOf(scale);
    return idx !== -1 ? idx : DEFAULT_INDEX;
  }, [scale]);

  return (
    <div className="flex items-center gap-2">
      <label className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap select-none">
        {scale}x
      </label>
      <input
        type="range"
        min={0}
        max={SCALE_STEPS.length - 1}
        step={1}
        value={currentIndex}
        onChange={(e) => onScaleChange(SCALE_STEPS[Number(e.target.value)])}
        className="w-24 h-2 accent-blue-500 cursor-pointer"
        title={`Kartengröße: ${scale}x`}
      />
    </div>
  );
}
